export interface Bq9EngineRoomM {
  vesselHasShaftGenerator: string;
  vesselHasShaftGeneratorComments: string;
  propulsionEngineMakeModel: string;
  propulsionEngineType: string;
  mainEngineMcrBhp: string;
  mainEngineMcrRpm: string;
  mainEngineNcrBhp: string;
  mainEngineNcrRpm: string;
  mainPropulsionFuelType: string;
  mainPropulsionOtherFuelSelected: boolean;
  mainPropulsionFuelTypeComments: string;
  mainPropulsionFuelUseCalculated: string;
  mainPropulsionFuelCalculatedTotal: string;
  mainPropulsionFuelTotal: string;
  generatingPlantFuelType: string;
  generatingPlantFuelTypeComments: string;
  generatingPlantFuelUseCalculated: string;
  generatingPlantFuelCalculatedTotal: string;
  generatingPlantFuelTotal: string;
  ballastMaxSpeedKnots: string;
  ballastMaxSpeedKnotsComments: string;
  ballastEconSpeedKnots: string;
  ballastEconSpeedKnotsComments: string;
  ladenMaxSpeedKnots: string;
  ladenMaxSpeedKnotsComments: string;
  ladenEconSpeedKnots: string;
  ladenEconSpeedKnotsComments: string;
  mainEngineBallastConsMTComments: string;
  mainEngineBallastConsMT: string;
  auxEngineBallastConsMTComments: string;
  auxEngineBallastConsMT: string;
  mainEngineLadenConsMTComments: string;
  mainEngineLadenConsMT: string;
  auxEngineLadenConsMTComments: string;
  auxEngineLadenConsMT: string;
  mainEngineWorkingConsMTComments: string;
  mainEngineWorkingConsMT: string;
  auxEngineWorkingConsMTComments: string;
  auxEngineWorkingConsMT: string;
  mainEngineAnchorConsMTComments: string;
  mainEngineAnchorConsMT: string;
  auxEngineAnchorConsMTComments: string;
  auxEngineAnchorConsMT: string;
  mainEngineOtherConsMTComments: string;
  mainEngineOtherConsMT: string;
  auxEngineOtherConsMTComments: string;
  auxEngineOtherConsMT: string;
  additionalInfoSpeedConsumption: string;

  // Environmental/Emissions
  hasEEDIRating: string;
  eediNumber: string;
  eediNoReason: string;
  eediVerifiedBy: string;
  hasEEXIRating: string;
  eexiRating: string;
  eexiNoReason: string;
  eexiVerifiedBy: string;
  hasCIIRating: string;
  ciiRating: string;
  ciiNoReason: string;
  ciiVerifiedBy: string;
  yearToDateCII: string;
  hasEIVRating: string;
  eivRating: string;
  eivNoReason: string;
  eivVerifiedBy: string;
  shipNOxControlLevel: string;
  noxReductionTech: string[];
  ownersAcceptBiofuel: string;
  vesselHasEGCS: string;
  scrubberType: string;
  scrubberTankCapacity: string;
}

export const initalBq9EngineRoom: Bq9EngineRoomM = {
  vesselHasShaftGeneratorComments: "",
  vesselHasShaftGenerator: "",
  propulsionEngineMakeModel: "",
  propulsionEngineType: "",
  mainEngineMcrBhp: "",
  mainEngineMcrRpm: "",
  mainEngineNcrBhp: "",
  mainEngineNcrRpm: "",
  mainPropulsionFuelType: "",
  mainPropulsionOtherFuelSelected: false,
  mainPropulsionFuelTypeComments: "",
  mainPropulsionFuelUseCalculated: "",
  mainPropulsionFuelCalculatedTotal: "",
  mainPropulsionFuelTotal: "",
  generatingPlantFuelType: "",
  generatingPlantFuelTypeComments: "",
  generatingPlantFuelUseCalculated: "",
  generatingPlantFuelCalculatedTotal: "",
  generatingPlantFuelTotal: "",
  ballastMaxSpeedKnots: "",
  ballastMaxSpeedKnotsComments: "",
  ballastEconSpeedKnots: "",
  ballastEconSpeedKnotsComments: "",
  ladenMaxSpeedKnots: "",
  ladenMaxSpeedKnotsComments: "",
  ladenEconSpeedKnots: "",
  ladenEconSpeedKnotsComments: "",
  mainEngineBallastConsMTComments: "",
  mainEngineBallastConsMT: "",
  auxEngineBallastConsMTComments: "",
  auxEngineBallastConsMT: "",
  mainEngineLadenConsMTComments: "",
  mainEngineLadenConsMT: "",
  auxEngineLadenConsMTComments: "",
  auxEngineLadenConsMT: "",
  mainEngineWorkingConsMTComments: "",
  mainEngineWorkingConsMT: "",
  auxEngineWorkingConsMTComments: "",
  auxEngineWorkingConsMT: "",
  mainEngineAnchorConsMTComments: "",
  mainEngineAnchorConsMT: "",
  auxEngineAnchorConsMTComments: "",
  auxEngineAnchorConsMT: "",
  mainEngineOtherConsMTComments: "",
  mainEngineOtherConsMT: "",
  auxEngineOtherConsMTComments: "",
  auxEngineOtherConsMT: "",
  additionalInfoSpeedConsumption: "",
  hasEEDIRating: "",
  eediNumber: "",
  eediNoReason: "",
  eediVerifiedBy: "",
  hasEEXIRating: "",
  eexiRating: "",
  eexiNoReason: "",
  eexiVerifiedBy: "",
  hasCIIRating: "",
  ciiRating: "",
  ciiNoReason: "",
  ciiVerifiedBy: "",
  yearToDateCII: "",
  hasEIVRating: "",
  eivRating: "",
  eivNoReason: "",
  eivVerifiedBy: "",
  shipNOxControlLevel: "",
  noxReductionTech: [],
  ownersAcceptBiofuel: "",
  vesselHasEGCS: "",
  scrubberType: "",
  scrubberTankCapacity: "",
};

export function mapSqlToBq9EngineRoomForm(genInfo: any): Bq9EngineRoomM {
  return {
    vesselHasShaftGeneratorComments: genInfo?.VESSEL_HAS_SHAFT_GENERATOR_COMMENTS || "",
    vesselHasShaftGenerator: genInfo?.VESSEL_HAS_SHAFT_GENERATOR || "",
    propulsionEngineMakeModel: genInfo?.PROPULSION_ENGINE_MAKE_MODEL || "",
    propulsionEngineType: genInfo?.PROPULSION_ENGINE_TYPE || "",
    mainEngineMcrBhp: genInfo?.MAIN_ENGINE_MCR_BHP || "",
    mainEngineMcrRpm: genInfo?.MAIN_ENGINE_MCR_RPM || "",
    mainEngineNcrBhp: genInfo?.MAIN_ENGINE_NCR_BHP || "",
    mainEngineNcrRpm: genInfo?.MAIN_ENGINE_NCR_RPM || "",
    mainPropulsionFuelType: genInfo?.MAIN_PROPULSION_FUEL_TYPE || "",
    mainPropulsionOtherFuelSelected: genInfo?.MAIN_PROPULSION_OTHER_FUEL_SELECTED || false,
    mainPropulsionFuelTypeComments: genInfo?.MAIN_PROPULSION_FUEL_TYPE_COMMENTS || "",
    mainPropulsionFuelUseCalculated: genInfo?.MAIN_PROPULSION_FUEL_USE_CALCULATED || "",
    mainPropulsionFuelCalculatedTotal: genInfo?.MAIN_PROPULSION_FUEL_CALCULATED_TOTAL || "",
    mainPropulsionFuelTotal: genInfo?.MAIN_PROPULSION_FUEL_TOTAL || "",
    generatingPlantFuelType: genInfo?.GENERATING_PLANT_FUEL_TYPE || "",
    generatingPlantFuelTypeComments: genInfo?.GENERATING_PLANT_FUEL_TYPE_COMMENTS || "",
    generatingPlantFuelUseCalculated: genInfo?.GENERATING_PLANT_FUEL_USE_CALCULATED || "",
    generatingPlantFuelCalculatedTotal: genInfo?.GENERATING_PLANT_FUEL_CALCULATED_TOTAL || "",
    generatingPlantFuelTotal: genInfo?.GENERATING_PLANT_FUEL_TOTAL || "",
    ballastMaxSpeedKnots: genInfo?.BALLAST_MAX_SPEED_KNOTS || "",
    ballastMaxSpeedKnotsComments: genInfo?.BALLAST_MAX_SPEED_KNOTS_COMMENTS || "",
    ballastEconSpeedKnots: genInfo?.BALLAST_ECON_SPEED_KNOTS || "",
    ballastEconSpeedKnotsComments: genInfo?.BALLAST_ECON_SPEED_KNOTS_COMMENTS || "",
    ladenMaxSpeedKnots: genInfo?.LADEN_MAX_SPEED_KNOTS || "",
    ladenMaxSpeedKnotsComments: genInfo?.LADEN_MAX_SPEED_KNOTS_COMMENTS || "",
    ladenEconSpeedKnots: genInfo?.LADEN_ECON_SPEED_KNOTS || "",
    ladenEconSpeedKnotsComments: genInfo?.LADEN_ECON_SPEED_KNOTS_COMMENTS || "",
    mainEngineBallastConsMTComments: genInfo?.MAIN_ENGINE_BALLAST_CONS_MT_COMMENTS || "",
    mainEngineBallastConsMT: genInfo?.MAIN_ENGINE_BALLAST_CONS_MT || "",
    auxEngineBallastConsMTComments: genInfo?.AUX_ENGINE_BALLAST_CONS_MT_COMMENTS || "",
    auxEngineBallastConsMT: genInfo?.AUX_ENGINE_BALLAST_CONS_MT || "",
    mainEngineLadenConsMTComments: genInfo?.MAIN_ENGINE_LADEN_CONS_MT_COMMENTS || "",
    mainEngineLadenConsMT: genInfo?.MAIN_ENGINE_LADEN_CONS_MT || "",
    auxEngineLadenConsMTComments: genInfo?.AUX_ENGINE_LADEN_CONS_MT_COMMENTS || "",
    auxEngineLadenConsMT: genInfo?.AUX_ENGINE_LADEN_CONS_MT || "",
    mainEngineWorkingConsMTComments: genInfo?.MAIN_ENGINE_WORKING_CONS_MT_COMMENTS || "",
    mainEngineWorkingConsMT: genInfo?.MAIN_ENGINE_WORKING_CONS_MT || "",
    auxEngineWorkingConsMTComments: genInfo?.AUX_ENGINE_WORKING_CONS_MT_COMMENTS || "",
    auxEngineWorkingConsMT: genInfo?.AUX_ENGINE_WORKING_CONS_MT || "",
    mainEngineAnchorConsMTComments: genInfo?.MAIN_ENGINE_ANCHOR_CONS_MT_COMMENTS || "",
    mainEngineAnchorConsMT: genInfo?.MAIN_ENGINE_ANCHOR_CONS_MT || "",
    auxEngineAnchorConsMTComments: genInfo?.AUX_ENGINE_ANCHOR_CONS_MT_COMMENTS || "",
    auxEngineAnchorConsMT: genInfo?.AUX_ENGINE_ANCHOR_CONS_MT || "",
    mainEngineOtherConsMTComments: genInfo?.MAIN_ENGINE_OTHER_CONS_MT_COMMENTS || "",
    mainEngineOtherConsMT: genInfo?.MAIN_ENGINE_OTHER_CONS_MT || "",
    auxEngineOtherConsMTComments: genInfo?.AUX_ENGINE_OTHER_CONS_MT_COMMENTS || "",
    auxEngineOtherConsMT: genInfo?.AUX_ENGINE_OTHER_CONS_MT || "",
    additionalInfoSpeedConsumption: genInfo?.ADDITIONAL_INFO_SPEED_CONSUMPTION || "",
    hasEEDIRating: genInfo?.HAS_EEDI_RATING || "",
    eediNumber: genInfo?.EEDI_NUMBER || "",
    eediNoReason: genInfo?.EEDI_NO_REASON || "",
    eediVerifiedBy: genInfo?.EEDI_VERIFIED_BY || "",
    hasEEXIRating: genInfo?.HAS_EEXI_RATING || "",
    eexiRating: genInfo?.EEXI_RATING || "",
    eexiNoReason: genInfo?.EEXI_NO_REASON || "",
    eexiVerifiedBy: genInfo?.EEXI_VERIFIED_BY || "",
    hasCIIRating: genInfo?.HAS_CII_RATING || "",
    ciiRating: genInfo?.CII_RATING || "",
    ciiNoReason: genInfo?.CII_NO_REASON || "",
    ciiVerifiedBy: genInfo?.CII_VERIFIED_BY || "",
    yearToDateCII: genInfo?.YEAR_TO_DATE_CII || "",
    hasEIVRating: genInfo?.HAS_EIV_RATING || "",
    eivRating: genInfo?.EIV_RATING || "",
    eivNoReason: genInfo?.EIV_NO_REASON || "",
    eivVerifiedBy: genInfo?.EIV_VERIFIED_BY || "",
    shipNOxControlLevel: genInfo?.SHIP_NOX_CONTROL_LEVEL || "",
    noxReductionTech: genInfo?.NOX_REDUCTION_TECH || "",
    ownersAcceptBiofuel: genInfo?.OWNERS_ACCEPT_BIOFUEL || "",
    vesselHasEGCS: genInfo?.VESSEL_HAS_EGCS || "",
    scrubberType: genInfo?.SCRUBBER_TYPE || "",
    scrubberTankCapacity: genInfo?.SCRUBBER_TANK_CAPACITY || "",
  };
}
